import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center justify-between w-full" }
const _hoisted_2 = ["placeholder", "readonly"]
const _hoisted_3 = {
  class: "absolute z-50 w-full mr-10 overflow-y-auto rounded-lg -left-4 top-12 dropdown custumScroll bg-secondary",
  style: {"max-height":"10rem"}
}
const _hoisted_4 = { class: "px-2 py-2" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "p-0 mb-1 -mt-2 text-sm text-red-400"
}

import { ref, watch, computed, nextTick } from 'vue';
import { onClickOutside } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectTag',
  props: {
  icon: { type: String, default: '/media/icons/arrow-down-icon.svg' },
  data: { type: String, default: '[]' },
  placeholder: { type: String, default: 'Change the placeholder' },
  css: { type: String, default: '' },
  value: { type: [Object, String], default: null },
  error: { type: String, default: '' },
  selected: { type: [String, Number], default: '0' },
  searchable: { type: Boolean, default: false },
  mode: { type: String as () => 'offline' | 'online', default: 'offline' },
  onSearch: { type: Function , default: null }
},
  emits: ['model'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const dropdownOpen = ref(false);
const dropdownRef = ref(null);
const inputRef = ref<HTMLInputElement | null>(null);
const selectedItem = ref<any>(null);
const highlightedIndex = ref<number>(-1);
const searchTerm = ref('');
const rawData = ref<any[]>([]);

// Init data depuis props.data
watch(() => props.data, () => {
  try {
    rawData.value = JSON.parse(props.data);
  } catch (e) {
    console.error('Invalid JSON data:', e);
    rawData.value = [];
  }
}, { immediate: true });

// Recherche offline ou online
watch(searchTerm, async (term) => {
  if (!props.searchable) return;

  if (props.mode === 'online' && typeof props.onSearch === 'function') {
    try {
      rawData.value = await props.onSearch(term);
    } catch (e) {
      console.error('Erreur lors de la recherche online:', e);
      rawData.value = [];
    }
  }
}, { immediate: true });

// Filtrage local
const parsedData = computed(() => {
  if (props.searchable && props.mode === 'offline') {
    return rawData.value.filter((item: any) =>
      item.value.toLowerCase().includes(searchTerm.value.toLowerCase())
    );
  }
  return rawData.value;
});

onClickOutside(dropdownRef, () => {
  dropdownOpen.value = false;
});

watch(() => props.selected, () => {
  // Si selected est falsy (null, undefined, 0, "0", "") → parent veut
  // explicitement effacer la sélection : on reset selectedItem ET
  // searchTerm pour revenir au placeholder. Sans ce reset, après un
  // premier choix il devenait impossible de "désélectionner".
  // Normalisation via String() : la prop est typée String mais Vue ne
  // garantit pas la coercion d'un number 0 passé en runtime — on harmonise.
  const sel = String(props.selected ?? "");
  if (sel === "" || sel === "0") {
    selectedItem.value = null;
    searchTerm.value = "";
    return;
  }
  // Comparaison souple : key peut être number côté data, string côté props.
  const match = rawData.value.find((item: any) => String(item.key) === sel);
  if (match) {
    selectedItem.value = match;
    searchTerm.value = match.value;
  }
}, { immediate: true });

const openDropdown = async () => {
  dropdownOpen.value = true;
  highlightedIndex.value = rawData.value.findIndex(item => item.key == selectedItem.value?.key);
  await nextTick();
};

const selectItem = (item: any, event: Event) => {
  event.stopPropagation();
  selectedItem.value = item;
  searchTerm.value = item.value;
  emit('model', item);
  dropdownOpen.value = false;
};

const handleKeydown = (event: KeyboardEvent) => {
  if (!dropdownOpen.value) {
    dropdownOpen.value = true;
    return;
  }

  const max = parsedData.value.length - 1;

  if (event.key === 'ArrowDown') {
    event.preventDefault();
    highlightedIndex.value = (highlightedIndex.value + 1) > max ? 0 : highlightedIndex.value + 1;
  }

  if (event.key === 'ArrowUp') {
    event.preventDefault();
    highlightedIndex.value = (highlightedIndex.value - 1) < 0 ? max : highlightedIndex.value - 1;
  }

  if (event.key === 'Enter') {
    event.preventDefault();
    const item = parsedData.value[highlightedIndex.value];
    if (item) selectItem(item, event);
  }

  if (event.key === 'Escape' || event.key === 'Tab') {
    dropdownOpen.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-col space-y-1",
    ref_key: "dropdownRef",
    ref: dropdownRef
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([__props.css, 'relative flex flex-row items-center px-4 py-2 my-2 space-x-4 bg-transparent border rounded-lg border-secondary focus-within:ring-2 focus-within:ring-secondary-700 focus-within:ring-inset']),
      onClick: openDropdown
    }, [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          ref_key: "inputRef",
          ref: inputRef,
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
          onKeydown: handleKeydown,
          class: "w-full text-white placeholder-gray-500 bg-transparent outline-none focus:outline-none autofill:bg-green-800 peer",
          placeholder: __props.placeholder,
          readonly: __props.searchable ? false : true
        }, null, 40, _hoisted_2), [
          [_vModelText, searchTerm.value]
        ]),
        _createVNode(_component_Icon, {
          src: __props.icon,
          class: _normalizeClass(['w-5 h-5 transition-transform duration-300', { 'rotate-180': dropdownOpen.value }])
        }, null, 8, ["src", "class"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parsedData.value, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.key,
              class: _normalizeClass(["flex items-center px-4 py-1 mb-1 rounded-lg cursor-pointer min-h-10", {
              'bg-accent text-gray-800': index === highlightedIndex.value,
              'hover:bg-accent hover:text-gray-800': index !== highlightedIndex.value
            }]),
              onClick: ($event: any) => (selectItem(item, $event))
            }, _toDisplayString(item.value), 11, _hoisted_5))
          }), 128))
        ])
      ], 512), [
        [_vShow, dropdownOpen.value]
      ])
    ], 2),
    (__props.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.error), 1))
      : _createCommentVNode("", true)
  ], 512))
}
}

})